import React, { useState } from "react";
import PropTypes from "prop-types";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useApi } from "../../../../../context/api.js";
import MDButton from "../../../../../components/MDButton";
import MDTypography from "../../../../../components/MDTypography";
import CircularProgress from "@mui/material/CircularProgress";
import { formatDate } from "../../../../../utils/date.js";
import { setMilestone, useHomework } from "../../../../../context/homework";

function AutonomousValidation({ m, from, title, onCancel }) {
  const api = useApi();
  const [_, dispatch] = useHomework();
  const [loading, setLoading] = useState(0);

  const handleAccept = () => {
    setLoading(1);
    api
      .validateMilestone(m.id, from)
      .then((res) => {
        setLoading(0);
        if (res) {
          setMilestone(dispatch, m.id, from, null);
          onCancel();
        } else {
          // TODO : Show error ?
        }
      })
      .catch((err) => {
        setLoading(false);
        // TODO : Show error ?
      });
  };

  return (
    <>
      <DialogContent>
        {title}
        <MDTypography variant="body" component="div" mt={2}>
          {"Vous êtes sur le point de valider cette étape de votre enfant."}
        </MDTypography>
      </DialogContent>
      <DialogActions>
        <MDButton variant="contained" color="success" disabled={!!loading} onClick={handleAccept}>
          {loading === 1 && <CircularProgress size={24} />}
          {loading !== 1 && "Valider son étape"}
        </MDButton>
      </DialogActions>
    </>
  );
}

AutonomousValidation.propTypes = {
  m: PropTypes.object.isRequired,
  from: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.element,
};

export default AutonomousValidation;
